import api from '@/utils/api'

export default {
    getAllTestLists(page, perPage, field, order) {
        const sort = (field && order) ? [field, order] : []
        const query = page && perPage && `sort=${JSON.stringify(sort)}&` +
            `range=${JSON.stringify([page - 1, perPage])}`
        return api.get(`test-lists${query ? `?${encodeURI(query)}` : ''}`)
    },
    createTestList(testList) {
        return api.post('test-lists', testList)
    },
    updateTestList(testList) {
        return api.put(`test-lists/${testList.id}`, testList)
    },
    deleteTestList(id) {
        return api.delete(`test-lists/${id}`)
    },
    getTestListById(id) {
        return api.get(`test-lists/${id}`)
    }
}
